export default __webpack_public_path__ + "static/media/exame.c9f42775.png";